module.exports = __webpack_public_path__ + "static/media/ratings_image.2bf1f77f.png";